module.exports = __webpack_public_path__ + "img/9788936505349.e7e955d0.jpg";